import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: #faf8f5;
  padding: 70px 0 30px;
  overflow-y: auto;
`;

export const MenuItemsContainer = styled.div`
  width: calc(100% - 32px);
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  margin: 20px auto 100px;
  box-sizing: border-box;
`;

export const ItemWrapper = styled.div`
  box-shadow: 0.5px 1.5px #9c8162;
  transition: 0.3s;
  border-radius: 15px;
  border-width: 1px;
  border-style: solid;
  border-color: black;
  color: black;
  display: flex;
  flex-direction: column;
  background-color: #fdf8f2;
  width: 100%;
  height: 60px;
`;

export const ImageWrapper = styled.div`
  flex: 1;
  padding: 10px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const Image = styled.img`
  margin-block: 10px;
`;

export const Text = styled.p`
  font-size: 12px;
  color: black;
  font-weight: 400;
  text-align: center;
  margin-block: 5px;
  margin-inline: 5px;
`;

export const Footer = styled.footer`
  width: 100%;
  background-color: #9c8162;
  text-align: center;
  position: fixed;
  bottom: 0;
  padding: 5px 0;

  a {
    font-size: 12px;
    margin: 0;
    text-decoration: none;
    color: #fdf8f2;
  }
`;

export const IconWrapper = styled.div`
  width: 30px;
  height: 30px;
`;

export const Header = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  position: fixed;
  top: 0;
  z-index: 10;

  background-color: #9c8162;

  color: #f8f5ef;

  p {
    margin-left: 12px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: .5px;
  }
`;
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 50px;
  padding-bottom: 30px;
`;

export const ItemContainer = styled.div<{ isFirst: any }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 18px 16px;
  margin: 0 16px;

  border-top: ${(props) =>
    props.isFirst ? "none" : "1px solid rgba(200,164,90,.35)"};

  transition: .25s;

  &:active {
    background: rgba(200,164,90,.08);
  }
`;

export const TextWrapper = styled.div<{ isDescription?: any }>`
  display: flex;
  flex-direction: ${(props) =>
    props.isDescription ? "column" : "row"};
  align-items: baseline;
  gap: 6px;
`;

export const Title = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #1f1f1f;
  text-transform: uppercase;
  letter-spacing: .4px;
`;

export const Subtitle = styled.p`
  margin: 0;
  color: #9c8162;
  font-size: 10px;
  font-weight: 500;
  margin-left: 5px
`;

export const Price = styled.p`
  margin: 0;
  color: black;
  font-size: 12px;
  font-weight: 700;
`;

export const SectionTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 28px 16px 14px;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #9c8162;
  }

  p {
    margin: 0;
    color: #1f1f1f;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
  }
`;

export const Description = styled.p`
  margin-top: 4px;
  color: #9c8162;
  font-size: 13px;
  line-height: 18px;
  text-transform: none;
`;
